import { DealerContextSelector } from "@components/DealerContextSelector";
import { Menu } from "@components/Settings/Menu";
import LytefloLogo from "@lyteflo/assets/logos/lyteflo.svg?react";
import LytefloOneCharacterLogo from "@lyteflo/assets/logos/lyteflo-accent.svg?react";
import { PortalRoutes } from "@lyteflo/types";
import { useMobile } from "@lyteflo/utils";
import { useLocation } from "wouter";

export const Header = () => {
  const isMobile = useMobile();
  const [, setLocation] = useLocation();

  return (
    <header className="lf-sticky lf-top-0 lf-z-100 lf-bg-color lf-flex lf-h-16 lf-items-center lf-border-b-2 lf-border-[var(--gray-3)]">
      <div className="lf-flex lf-items-center lf-justify-between lf-w-full lf-min-w-0">
        <button
          className="lf-shrink-0 lf-h-8 lf-mr-4 lf-pl-3"
          onClick={() => {
            setLocation(PortalRoutes.HOME);
          }}
        >
          {isMobile ? (
            <LytefloOneCharacterLogo
              title="Lyteflo"
              aria-label="Lyteflo"
              className="lf-w-auto lf-h-8"
            />
          ) : (
            <LytefloLogo
              title="Lyteflo"
              aria-label="Lyteflo"
              className="lf-w-auto lf-h-8"
            />
          )}
        </button>
        <div className="lf-min-w-0 lf-flex-1 lf-flex lf-justify-center">
          <DealerContextSelector />
        </div>
        <div className="lf-shrink-0 lf-flex lf-items-center">
          <Menu />
        </div>
      </div>
    </header>
  );
};
